module.exports = __webpack_public_path__ + "static/img/agent.bbed8503.png";